require('./insufficientAccounts.scss');

const React = require('react');
const { formatText } = require('core/i18n').i18n;
const classPrefix= 'insufficientAccounts';

class InsufficientAccounts extends React.Component {
    buildInfo() {
        return (
            <p className="signature-key-locked__info">
                {formatText(classPrefix + '-info') + ' '}
                <b>{formatText(classPrefix + '-infoFirstPhone') + ' '}</b>
                {formatText(classPrefix + '-or') + ' '}
                <b>{formatText(classPrefix + '-infoSecondPhone') + '.'}</b>
            </p>
        )
    }

    render() {
        const walletsImgDescription = formatText('imgDescription-insufficientAccounts');
        const walletsIcon = require('assets/images/icon-wallets-emptystate.svg');

        return (
            <div className="insufficient-accounts">
                <div>
                    <img src={walletsIcon} alt={walletsImgDescription} />
                </div>
                <div className="insufficient-accounts__title">
                    {formatText(classPrefix + '-passTitle')}
                </div>
                <div className="insufficient-accounts__text">
                    {formatText(classPrefix + '-passText')}
                </div>
            </div>
        )
    }

}

module.exports = InsufficientAccounts;

